import { Component, OnInit } from '@angular/core';
import { DownloadModalService } from '../../services/download-modal.service';
import { environment } from '../../../environments/environment';

const BASE_URL = environment.apiUrl;
const API_BASE_URL = `${BASE_URL}/api`;

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent implements OnInit {
  packages: any[] = [];
  constructor(private downloadModal: DownloadModalService) { }
  ngOnInit() {
    this.fetchPackages();
  }

  async fetchPackages() {
    try {
      const response = await fetch(`${API_BASE_URL}/packages/home_masters`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      const result = await response.json();
      console.log('API Response:', result);
      if (result.statusCode === 200) {
        if (result.data && result.data.packages) {
          this.packages = result.data.packages;
        } 
      } else {
        console.error('API Error:', result);
      }
    } catch (error) {
      console.error('Request failed:', error);
    }
  }

  openDownload(event: Event, pkg?: any) {
    event.preventDefault();
    this.downloadModal.open(pkg ? { package_id: pkg.id } : null);
  }
}